exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3MHe_BUx8LKKBDtnDqHlrU{color:#d83b01}._25qARd70RPym5yJb5tmUEf{color:#107c10}.o7piBJ_Vz5hurpSuZP43F{font-size:14px}html[dir=ltr] .o7piBJ_Vz5hurpSuZP43F{margin-right:4px}html[dir=rtl] .o7piBJ_Vz5hurpSuZP43F{margin-left:4px}._3wgOrTSDqpwBz0iK6gcwG7{height:18px;width:18px}html[dir] ._3wgOrTSDqpwBz0iK6gcwG7.ms-Button{padding:0}._3wgOrTSDqpwBz0iK6gcwG7.ms-Button .ms-Icon{font-size:14px}html[dir] ._3wgOrTSDqpwBz0iK6gcwG7.ms-Button .ms-Icon{margin:0}", ""]);

// exports
exports.locals = {
	"error": "_3MHe_BUx8LKKBDtnDqHlrU",
	"checkmark": "_25qARd70RPym5yJb5tmUEf",
	"leftIcon": "o7piBJ_Vz5hurpSuZP43F",
	"rightIcon": "_3wgOrTSDqpwBz0iK6gcwG7"
};